import { FC } from 'react';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useSignOut } from '../../security/hooks/useSignOut';
import { AvatarMenuItem } from '../component/AvatarMenuItem';

type Props = {
  divider: boolean;
};

export const SignOutContainer: FC<Props> = ({ divider }) => {
  const topBarBlock = StaticContentService.getPublicBlock('webHcpNavigationHeader', 'topBar');

  const { signOut } = useSignOut();

  return (
    <AvatarMenuItem
      onClick={signOut}
      title={topBarBlock.button.signOut.label}
      iconProps={{ name: 'logout', color: 'black' }}
      divider={divider}
    />
  );
};
